// オブジェクトの中身の比較を行う関数
/**
 * ２つのオブジェクトの中身が同じかどうか判定する
 * @param a 比較対象a
 * @param b 比較対象b
 */
export const objectEquals = (a, b) => {
  const aJSON = JSON.stringify(objectSort(a));
  const bJSON = JSON.stringify(objectSort(b));
  return aJSON === bJSON;
};

/**
 * オブジェクトのソートを行う
 * @param obj ソート対象のオブジェクト
 * @returns ソート済みオブジェクト
 */
function objectSort(obj) {
  // ソートする
  // ソート不可のオブジェクトが来た場合、弾く
  if (!obj) return '';
  const sorted = Object.entries(obj).sort();

  // valueを調べ、objectならsorted entriesに変換する
  for (const i in sorted) {
    const val = sorted[i][1];
    if (typeof val === 'object') {
      sorted[i][1] = objectSort(val);
    }
  }

  return sorted;
}
